import { render } from "./OfferPaymentTerms.vue?vue&type=template&id=4bc229d9&scoped=true"
import script from "./OfferPaymentTerms.vue?vue&type=script&lang=js"
export * from "./OfferPaymentTerms.vue?vue&type=script&lang=js"

import "./OfferPaymentTerms.vue?vue&type=style&index=0&id=4bc229d9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bc229d9"]])

export default __exports__